module.exports = __webpack_public_path__ + "static/media/check_mark.ae784141.svg";